import { render, staticRenderFns } from "./LocalizacaoAlteradaMapa.vue?vue&type=template&id=3e2f66c9&"
import script from "./LocalizacaoAlteradaMapa.vue?vue&type=script&lang=js&"
export * from "./LocalizacaoAlteradaMapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports